import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { pipelineRunsApi } from '@/lib/api/pipeline-runs.api';

const QK = ['pipeline-runs'];

export const usePipelineRuns = (params?: { configuration_id?: string; status?: string }) =>
  useQuery({
    queryKey: [...QK, params],
    queryFn: () => pipelineRunsApi.list(params),
  });

export const usePipelineRun = (id: string) =>
  useQuery({
    queryKey: [...QK, 'one', id],
    queryFn: () => pipelineRunsApi.get(id),
    refetchInterval: (query) => {
      const status = query.state.data?.status;
      return status === 'RUNNING' || status === 'QUEUED' ? 3000 : false;
    },
  });

export const useCreatePipelineRun = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: pipelineRunsApi.create,
    onSuccess: () => qc.invalidateQueries({ queryKey: QK }),
  });
};

export const useCancelPipelineRun = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: pipelineRunsApi.cancel,
    onSuccess: () => qc.invalidateQueries({ queryKey: QK }),
  });
};

export const usePromotePipelineRun = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: pipelineRunsApi.promote,
    onSuccess: () => qc.invalidateQueries({ queryKey: QK }),
  });
};

export const useDiscardPipelineRun = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: pipelineRunsApi.discard,
    onSuccess: () => qc.invalidateQueries({ queryKey: QK }),
  });
};

export const usePipelineRunReport = (id: string) =>
  useQuery({
    queryKey: [...QK, 'report', id],
    queryFn: () => pipelineRunsApi.getReport(id),
    enabled: !!id,
  });

export const useResendReport = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: pipelineRunsApi.resendReport,
    onSuccess: (_, id) => qc.invalidateQueries({ queryKey: [...QK, 'report', id] }),
  });
};
